import type { WeddingForm } from "../WeddingForm.js";
import { WeddingFormStatus } from "../WeddingFormStatus.js";

export function canBuyFillings(weddingForm: WeddingForm | undefined): weddingForm is WeddingForm {
	return (
		weddingForm?.fillingTasteTest === true &&
		weddingForm.status === WeddingFormStatus.Approved &&
		weddingForm.orderId === undefined
	);
}
